import { render, staticRenderFns } from "./ComplianceReviewHistory.vue?vue&type=template&id=58f2b6bc&scoped=true"
import script from "./ComplianceReviewHistory.vue?vue&type=script&lang=js"
export * from "./ComplianceReviewHistory.vue?vue&type=script&lang=js"
import style0 from "./ComplianceReviewHistory.vue?vue&type=style&index=0&id=58f2b6bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f2b6bc",
  null
  
)

export default component.exports